import { Box, Button, Grid } from '@mui/material';
import BaseTextField from 'common/components/base-text-field';
import FormProvider from 'common/components/form-provider';
import RequiredLabel from 'common/components/required-label';
import { styleInput } from 'common/constants';
import React from 'react';
import { useForm } from 'react-hook-form';
import UploadImage from '../survey/components/upload-image';
import BaseTextPasswordField from 'common/components/base-text-password-field';
import { ReactComponent as SyncIcon } from 'assets/images/icons/sync.svg';
// import CloseIcon from '@mui/icons-material/Close';
// import { common } from '@mui/material/colors';
import { yupResolver } from '@hookform/resolvers/yup';
import { generalConfigurationsSchema } from 'common/schema';
import {
    fetchSettingSystem,
    updateSettingSystem,
} from 'services/settingSystem.service';
import { handleError } from 'utils/helpers';
import { toast } from 'react-toastify';

const General: React.FC = () => {
    const methods = useForm({
        resolver: yupResolver(generalConfigurationsSchema),
        defaultValues: {
            email: '',
            hotline: '',
            logo: '',
            favicon: '',
            terms: '',
            copyRight: '',
            qr: '',
            password: '',
        },
    });

    const onSubmit = methods.handleSubmit(async (data) => {
        try {
            const response = await updateSettingSystem({
                setting: {
                    email_support: data.email,
                    hotline: data.hotline,
                    logo: data.logo,
                    favicon: data.favicon,
                    terms: data.terms,
                    copyright: data.copyRight,
                    qr_code: data.qr,
                    password_default: data.password,
                },
            });
            if (response.success) {
                toast.success(response.message);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    });

    // fetch data from API
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchSettingSystem();
                if (response.success) {
                    const { attributes } = response.data.setting;
                    methods.reset({
                        email: attributes.email_support || '',
                        hotline: attributes.hotline || '',
                        logo: attributes.logo.url,
                        favicon: attributes.favicon.url,
                        terms: attributes.terms || '',
                        copyRight: attributes.copyright || '',
                        qr: attributes.qr_code || '',
                        password: attributes.password_default || '',
                    });
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                handleError(error);
            }
        };
        fetchData();
    }, [methods]);

    return (
        <Box mt={2}>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <RequiredLabel required={false} label="Email hỗ trợ" />
                        <BaseTextField name="email" sx={styleInput} />
                    </Grid>
                    <Grid item xs={6}>
                        <RequiredLabel required={false} label="Số hotline" />
                        <BaseTextField
                            type="tel"
                            name="hotline"
                            sx={styleInput}
                            InputProps={{
                                inputProps: {
                                    maxLength: 20,
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <RequiredLabel required={false} label="Logo" />
                        <UploadImage
                            isDelete={true}
                            name={'logo'}
                            maxFileSize={20}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <RequiredLabel required={false} label="Favicon" />
                        <UploadImage
                            isDelete={true}
                            name={'favicon'}
                            maxFileSize={20}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <RequiredLabel required={false} label="Điều khoản" />
                        <BaseTextField
                            name="terms"
                            sx={styleInput}
                            placeholder="Điều khoản"
                            InputProps={{
                                inputProps: {
                                    maxLength: 2000,
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <RequiredLabel required={false} label="Copyright" />
                        <BaseTextField
                            name="copyRight"
                            sx={styleInput}
                            placeholder="Copyright"
                            InputProps={{
                                inputProps: {
                                    maxLength: 255,
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <RequiredLabel required={false} label="Mã QR" />
                        <BaseTextField
                            name="qr"
                            sx={styleInput}
                            placeholder="Mã QR"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <RequiredLabel
                            required={false}
                            label="Mật khẩu mặc định"
                        />
                        <BaseTextPasswordField
                            name="password"
                            fullWidth
                            sx={styleInput}
                            placeholder="Mật khẩu mặc định"
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        justifyContent={'flex-end'}
                        display="flex"
                        gap={2}
                    >
                        <Button
                            type="submit"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '20px',
                                borderRadius: '40px',
                                lineHeight: '24.2px',
                                minHeight: '60px',
                                minWidth: '230px',
                            }}
                            variant="contained"
                            startIcon={<SyncIcon />}
                        >
                            Cập nhật
                        </Button>
                        {/* <Button
                            variant="outlined"
                            startIcon={<CloseIcon />}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '20px',
                                borderRadius: '40px',
                                lineHeight: '24.2px',
                                minHeight: '60px',
                                minWidth: '230px',
                                backgroundColor: common.white,
                            }}
                        >
                            Đóng
                        </Button> */}
                    </Grid>
                </Grid>
            </FormProvider>
        </Box>
    );
};

export default General;
